import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import AddProduct from "./addProduct/AddProduct";
import classes from "./index.module.css";
import ProductReportFilter from "./ProductReportFilter";
import ProductReportSummary from "./ProductReportSummary";

const Products = () => {
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [productId, setProductId] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  // const [filterParams, setFilterParams] = useState(null);
  // const [filterStates, setFilterStates] = useState(null);

  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();

  // const refreshData = useCallback((filterData = {}) => {
  //   reportRef.current.applyFilters(filterData);
  // }, []);

  const addProduct = useCallback((isEdit = false) => {
    if (isEdit) {
      setProductId(reportRef.current.getCurrentRowData()?.medicineId);
    }
    setShowAddProduct(true);
  }, []);

  const closeProductAc = () => {
    setShowAddProduct(false);
    setProductId(null);
    setCurrentComponent("grid_reports");
  };

  const listener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const ctrlKey = e.ctrlKey;
    // if (altKey && key === "r") {
    //   return refreshData();
    // }
    if (ctrlKey && key === "e") {
      return editRef.current.click();
    }
    // if (ctrlKey && key === "m") {
    //   return addProduct();
    // }
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addProduct(true);
        }}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addProduct]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddProduct &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddProduct]);
  // useEffect(() => {
  //   refreshData();
  // }, [refreshData]);
  return (
    <div className={classes["product-report-container"]}>
      <Reports
        identifier="product"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        // filterParams={filterParams}
        // filterStates={filterStates}
        filters={
          <ProductReportFilter
            reportRef={reportRef}
            // refreshData={refreshData}
            // applyFilters={(params, filterStates) => {
            //   // refreshData(params);
            //   // setFilterParams(params);
            //   // setFilterStates(filterStates);
            // }}
            onFilterShow={onFilterShow}
          />
        }
      />
      <ProductReportSummary
        // refreshData={refreshData}
        showAutoComplete={() => {
          addProduct();
        }}
      />
      <Autocomplete
        show={showAddProduct}
        height="70%"
        width="90%"
        closeAutoComplete={closeProductAc}
      >
        <AddProduct
          editProductId={productId}
          onEscape={closeProductAc}
          onSave={closeProductAc}
        />
      </Autocomplete>
    </div>
  );
};

export default Products;
